import store from "@frameworks/web/redux/store";
import { FAQLIST_UPDATES, FAQLIST_UPDATES_ERROR, FAQLIST_UPDATES_HIDE_ERROR, FAQLIST_UPDATES_START_LOADER, FAQLIST_UPDATES_STOP_LOADER } from "@frameworks/web/redux/interfaces/StaticFooter/iFaqList";
class FaqActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getFaqData(data) {
        this.dispatch({
            type: FAQLIST_UPDATES,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: FAQLIST_UPDATES_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: FAQLIST_UPDATES_HIDE_ERROR,
        });
    }
    loader() {
        this.dispatch({
            type: FAQLIST_UPDATES_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: FAQLIST_UPDATES_STOP_LOADER,
        });
    }
}
export default FaqActions;
